<template>
  <div class="overflow-hidden">
    <h1 class="py-4 text-zt-lg text-zt-primary-200">{{ $t("message.DocumentsComponents.searchDocuments") }}</h1>
    <div class="main--container pr-6">
      <div :class="{ 'main--content__open': isSearchListVisible }" class="main--content max-h-full">
        <SearchList v-show="isSearchListVisible" />
        <SearchTable />
      </div>
    </div>
  </div>
</template>

<script>
import SearchList from '../components/SearchList'
import SearchTable from '../components/SearchTable'
import { store, mutations } from '../store'

export default {
  name: 'SearchDocumentsPage',
  provide: {
    store,
    ...mutations
  },
  components: {
    SearchList,
    SearchTable
  },
  computed: {
    isSearchListVisible() {
      return store.searchListVisible
    }
  }
}
</script>

<style scoped>
.main--container {
  max-height: calc(100vh - 74px - 32px - 40px);
}

.main--content {
  display: grid;

  column-gap: 24px;
}

.main--content__open {
  grid-template-columns: 25% 75%;
}

.main--content__close {
  grid-template-columns: 1fr;
}
</style>
